import React from "react";
import { Breadcrumb as CustomBreadCrumb } from "react-bootstrap";
import { COUNTRY_NAMES } from "../../../@types/Constants";
import { convertToWord } from "../../../utils/helpers";
import CustomLink from "../CustomLink/CustomLink";
import { breadCrumbCss, underLineText } from "./Breadcrumb.module.scss";
import { IBreadCrumbItemProps } from "./BreadcrumbProps";
import { useBreadcrumbSliceContext } from "../../../context/SliceContexts/BreadcrumbContext";

const Breadcrumb: React.FC = () => {
  const {
    location,
    activeTitle,
    countryCode,
    cityName = "",
    statePath,
    cityPath,
    cityParentAlias = "",
  } = useBreadcrumbSliceContext();

  const locationPath = location.pathname.split("/");
  const stateName =
    locationPath[3]?.length > 3 ? convertToWord(locationPath[3]) : "";
  let stateLink = "";
  let cityLink = "";
  let dynamicCityName = cityName;
  if (locationPath.length >= 6) {
    dynamicCityName =
      locationPath[4]?.length > 3 ? convertToWord(locationPath[4]) : "";
  }

  if (statePath?.path?.alias) {
    stateLink = statePath.path.alias;
  } else if (cityParentAlias) {
    stateLink = cityParentAlias;
  }

  if (cityPath?.path?.alias) {
    cityLink = cityPath.path.alias;
  }

  const hotelBreadCrumbProps: IBreadCrumbItemProps[] = [
    {
      title: COUNTRY_NAMES[countryCode],
      href: "",
      underlineLink: false,
      showCrumb: true,
    },
    {
      title: stateName,
      href: stateLink,
      underlineLink: !!stateLink,
      showCrumb: !!stateName,
    },
    {
      title: dynamicCityName,
      href: cityLink,
      underlineLink: !!cityLink,
      showCrumb: !!dynamicCityName,
    },
    {
      title: activeTitle,
      href: "",
      underlineLink: true,
      showCrumb: !!activeTitle,
    },
  ];

  return (
    <CustomBreadCrumb className={breadCrumbCss}>
      {hotelBreadCrumbProps.map((item) =>
        item.showCrumb ? (
          item.href ? (
            <CustomBreadCrumb.Item
              linkProps={{ to: item.href }}
              linkAs={CustomLink}
              active={false}
              key={item.title}
              className={item.underlineLink ? underLineText : ""}
            >
              {item.title}
            </CustomBreadCrumb.Item>
          ) : (
            <CustomBreadCrumb.Item
              key={item.title}
              active={true}
              className={item.underlineLink ? underLineText : ""}
            >
              {item.title}
            </CustomBreadCrumb.Item>
          )
        ) : null
      )}
    </CustomBreadCrumb>
  );
};

export default React.memo(Breadcrumb);
